/**
 * @format
 */

import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useUserWeeklySales } from '../hooks/useLeaderboard';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface WeeklySalesChartProps {
  userId: string;
  style?: React.CSSProperties;
}

const WeeklySalesChart: React.FC<WeeklySalesChartProps> = ({ userId, style }) => {
  const { data, loading, error } = useUserWeeklySales(userId);

  // Map REST API data (Monday=2 to Friday=6) to chart days (0-6)
  const chartData = {
    labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    datasets: [
      {
        label: 'Sales',
        data: Array.from({ length: 7 }, (_, i) => {
          // REST API uses dayOfWeek 2-6 (Mon-Fri), chart uses 0-6
          const dayData = data.find((item: any) => item.dayOfWeek === i + 2);
          return dayData ? dayData.totalSales : 0;
        }),
        backgroundColor: '#1C1C1C',
        borderWidth: 1,
        borderRadius: 20,
        barThickness: 7,
      },
      {
        label: 'Premium',
        data: Array.from({ length: 7 }, (_, i) => {
          const dayData = data.find((item: any) => item.dayOfWeek === i + 2);
          return dayData ? dayData.totalPremium : 0;
        }),
        backgroundColor: '#1c1c1c79',
        borderWidth: 1,
        borderRadius: 20,
        barThickness: 7,
      },
    ],
  };

  if (loading) {
    return <div style={style}>Loading chart...</div>;
  }

  if (error) {
    return <div style={{ color: 'red', ...style }}>Error: {error.message}</div>;
  }

  return (
    <div style={style}>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                display: false,
              },
            },
            x: {
              grid: {
                display: false,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default WeeklySalesChart;
